import React from 'react';
import { Star, FileText, Zap, Shield, ShieldCheck } from 'lucide-react';
export function Hero() {
  const handleCta = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-white px-4 md:py-16 min-h-[calc(100svh-36px)] md:min-h-0 flex flex-col overflow-hidden" data-id="element-108">
      {/* Decorative background accent — subtle orange glow behind product */}
      <div aria-hidden className="absolute inset-x-0 top-1/2 -translate-y-1/2 mx-auto w-[600px] h-[600px] rounded-full bg-sci-orange/5 blur-3xl pointer-events-none" data-id="element-109" />

      <div className="relative max-w-[680px] mx-auto text-center flex flex-col items-center justify-center flex-1 w-full py-4 md:py-0 gap-3 md:gap-6" data-id="element-110">
        {/* Promo pill */}
        <div className="inline-flex items-center gap-1.5 bg-sci-orange/10 text-sci-orange font-bold text-[10px] md:text-xs uppercase tracking-wider px-3 py-1 rounded-full border border-sci-orange/20" data-id="element-111">
          <Zap className="w-3 h-3" data-id="element-112" />
          <span data-id="element-113">-70% OFF · OFERTA DE LANZAMIENTO</span>
        </div>

        {/* Brand */}
        <div className="text-carbon font-bold text-[11px] md:text-sm tracking-[0.3em]" data-id="element-114">
          CIENCIAS 360
        </div>

        {/* Headline */}
        <h1 className="text-[24px] leading-[1.05] md:text-5xl font-extrabold text-carbon" data-id="element-115">
          TODO TU AÑO DE CIENCIAS
          <br data-id="element-116" />
          <span className="text-sci-orange" data-id="element-117">RESUELTO.</span>
        </h1>

        {/* Subheadline */}
        <h2 className="text-[13px] leading-snug md:text-xl text-gray-600 md:leading-relaxed max-w-md" data-id="element-118">
          <span className="md:hidden" data-id="element-119">
            MegaPack Ciencias 360 — 12 tomos para Física, Química y FQ
            secundaria AR
          </span>
          <span className="hidden md:inline" data-id="element-120">
            MegaPack Ciencias 360 — 12 tomos completos
            <br data-id="element-121" />
            para docentes de Física, Química y Físico-Química
            <br data-id="element-122" />
            de secundaria en Argentina
          </span>
        </h2>

        {/* Product Image */}
        <div className="flex justify-center w-full" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/a9fFrUi4NccDHjdJdNJFFY/202.png" alt="MegaPack Ciencias 360 — Elite Bundle 2 a 5 Secundario con 12 tomos y 6 bonus" className="w-auto max-h-[230px] md:max-h-[420px] h-auto drop-shadow-2xl" width={420} height={420} loading="eager"
        // @ts-ignore - fetchpriority is a valid HTML attribute
        fetchpriority="high" decoding="async" data-id="element-124" />
        </div>

        {/* Social proof: stars + count */}
        <div className="flex items-center gap-2" data-id="element-125">
          <div className="flex gap-0.5 text-sci-orange" aria-label="4.9 de 5 estrellas" data-id="element-126">
            <Star className="w-4 h-4 fill-sci-orange" data-id="element-127" />
            <Star className="w-4 h-4 fill-sci-orange" data-id="element-128" />
            <Star className="w-4 h-4 fill-sci-orange" data-id="element-129" />
            <Star className="w-4 h-4 fill-sci-orange" data-id="element-130" />
            <Star className="w-4 h-4 fill-sci-orange" data-id="element-131" />
          </div>
          <span className="text-[12px] md:text-sm text-gray-700 font-medium" data-id="element-132">
            <span className="font-bold" data-id="element-133">4.9/5</span> · +800 docentes argentinos
          </span>
        </div>

        {/* CTA + trust */}
        <div className="flex flex-col items-center w-full gap-2 md:gap-3 mt-1" data-id="element-134">
          <button onClick={handleCta} className="w-full max-w-md bg-sci-orange hover:bg-orange-600 active:scale-[0.98] text-white font-bold text-[15px] md:text-lg py-3.5 md:py-4 px-4 md:px-6 rounded-xl transition-all shadow-lg shadow-sci-orange/30" data-id="element-135">
            📚 → QUIERO MI CIENCIAS 360 AHORA
          </button>

          {/* Trust badges row — compact icon line */}
          <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[10.5px] md:text-sm text-gray-500" data-id="element-136">
            <span className="inline-flex items-center gap-1" data-id="element-137">
              <Shield className="w-3.5 h-3.5 text-bio-green" data-id="element-138" />
              Pago seguro
            </span>
            <span className="text-gray-300" data-id="element-139">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-140">
              <Zap className="w-3.5 h-3.5 text-sci-orange" data-id="element-141" />
              Acceso en 5 min
            </span>
            <span className="text-gray-300" data-id="element-142">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-143">
              <ShieldCheck className="w-3.5 h-3.5 text-bio-green" data-id="element-144" />
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}